import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { APP_PATHS } from '../app.paths';
import { tap } from 'rxjs';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.checkAuth().pipe(
    tap((isAuthenticated) => {
      if (!isAuthenticated) {
        router.navigate(['/', APP_PATHS.LOGIN], {
          queryParams: { redirect: state.url },
        });
      }
    }),
  );
};
